import { makeAutoObservable } from 'mobx';
import { RecoveryValidationError } from '../../../../../infrastructure/types/features/auth/auth-types';
import {
  invalid,
  validate,
} from '../../../../../../shared/logic/core-logic/validation/ValidationResult';
import { validationHelpers } from '../../../../../../shared/infrastructure/validation-rules/validation-helpers';
import { RestorePasswordManager } from '../managers/RestorePasswordManager';

class RestorePasswordValidator {
  constructor(private restoreManager: RestorePasswordManager) {
    makeAutoObservable(this, {});
  }

  get email() {
    const serverError = this.restoreManager.recoveryEmailError;
    if (serverError) {
      const errorKey =
        serverError === 'email not_found' ? RecoveryValidationError.EMAIL_NOT_FOUND : serverError;
      return invalid(errorKey);
    }

    const value = this.restoreManager.email;
    return validate(
      validationHelpers.notUndefinedOrNull(value) &&
        validationHelpers.notEmptyString(value as string),
      RecoveryValidationError.EMAIL_EMPTY,
    ).addCheckIfPreviousPassed(
      validationHelpers.emailCorrectFormat(value),
      RecoveryValidationError.EMAIL_INCORRECT,
    );
  }

  get password() {
    const value = this.restoreManager.newPassword;

    return validate(
      validationHelpers.notUndefinedOrNull(value) &&
        validationHelpers.notEmptyString(value as string),
      RecoveryValidationError.PASSWORD_EMPTY,
    ).addCheckIfPreviousPassed(
      (value?.length || 0) >= 6,
      RecoveryValidationError.PASSWORD_INCORRECT,
    );
  }

  get passwordConfirmation() {
    const value = this.restoreManager.passwordConfirmation;
    const password = this.restoreManager.newPassword;

    return validate(
      validationHelpers.notUndefinedOrNull(value) &&
        validationHelpers.notEmptyString(value as string),
      RecoveryValidationError.PASSWORD_EMPTY,
    ).addCheckIfPreviousPassed(
      value === password,
      RecoveryValidationError.PASSWORD_CONFIRM_MISMATCH,
    );
  }

  get hasErrors() {
    return this.email.hasErrors;
  }

  get hasResetErrors() {
    return this.password.hasErrors || this.passwordConfirmation.hasErrors;
  }
}

export { RestorePasswordValidator };
